module.exports = __webpack_public_path__ + "static/media/NotFoundShader.22c840ca.frag";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/Shaders/NotFoundShader.frag
// module id = 146
// module chunks = 0